require('./command.js');

(function(){
  PegasusTemplate.EditBlockCommand = PegasusTemplate.Command.extend({
    klass: null,
    backup: null,
    sourceElement: null,
    callback: null,
    pluckable: true,
    parent: function(){
      return PegasusTemplate.blockRegionInstance;
    },
    descriptionClass: 'edited',
    description: function(){
      return Em.I18n.t('command_descriptions.edited_content');
    }.property(),
    childPosition: null,
    execute: function() {
      var parent = this.parent(),
        element = this.get('klass').create({
          container: parent.container,
          sourceElement: this.get('sourceElement')
        }),
        callback = this.get('callback'),
        child = parent.objectAt( this.get('childPosition') );

      this.parent().removeObject( child );
      this.parent().insertAt( this.get('childPosition'), element );

      if ( callback ) {
        callback();
      }

      this._super();

      return element;
    },

    unexecute: function(callback){
      var parent = this.parent(),
        child = parent.objectAt( this.get('childPosition') ),
        reborn = this.get('klass').create({
          container: parent.container,
          sourceElement: this.get('backup')
        });

      parent.removeObject( child );
      parent.insertAt( this.get('childPosition'), reborn );

      this._super();
    }
  });
})();
